import { AppState } from "@store";
import { Action } from "redux";
import { all, select, takeEvery } from "redux-saga/effects";
import { getAdUnitAndFormatInfoRequest, getCampaignByIdRequest } from "@common";
import { campaignCreativesForm, campaignMediaPlanForm } from "@store";
import { generateFormsForCurrentAssets } from "../adUnitAssetBuilderForm";
import { adUnitAssetSelector } from "../selector/adUnitAssetSelector";

function* createFormsOnUpdateAssetsSaga() {
    const appState: AppState = yield select();

    const assetAttr = adUnitAssetSelector(appState);
    if (assetAttr) {
        generateFormsForCurrentAssets(assetAttr);
    }
}

export function* adUnitBuilderAssetFormSaga() {
    yield all([
        takeEvery(
            (a: Action) =>
                getCampaignByIdRequest.actions.isOk(a) ||
                getAdUnitAndFormatInfoRequest.actions.isOk(a) ||
                (campaignCreativesForm.actions.isFieldEdit(a) && a.field === "adUnitType") ||
                (campaignCreativesForm.actions.isSetData(a) && !!a.data.adUnitType) ||
                (campaignMediaPlanForm.actions.isFieldEdit(a) && a.field === "adUnitFormat"),
            createFormsOnUpdateAssetsSaga
        )
    ]);
}
